import { create } from "zustand";

export const useMigrationStore = create((set) => ({
  isMigrationActive: false,
  setIsMigrationActive: (isMigrationActive) => set({ isMigrationActive }),

  oldMacroData: {},
  setOldMacroData: (oldMacroData) => set({ oldMacroData }),
}));
